module.exports = __webpack_public_path__ + "assets/cameraSwitch@3x.febcc2ffa51cf0f7bdce8e3e28746488.png";